module.exports = __webpack_public_path__ + "static/media/hotel-legoland.1d5b26c1.jpg";